import { render, staticRenderFns } from "./addRegion.vue?vue&type=template&id=d01acc04&scoped=true&"
import script from "./addRegion.vue?vue&type=script&lang=js&"
export * from "./addRegion.vue?vue&type=script&lang=js&"
import style0 from "./addRegion.vue?vue&type=style&index=0&id=d01acc04&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d01acc04",
  null
  
)

export default component.exports